export default "__VITE_ASSET__BgO$ATaP__"